import {
  getPlatformV1AuditLogs,
  type GetPlatformV1AuditLogs200,
  type GetPlatformV1AuditLogsParams,
} from '@nucleus-commerce/api-client/platform';

export const auditLogApi = {
  list: (params: GetPlatformV1AuditLogsParams): Promise<GetPlatformV1AuditLogs200> =>
    getPlatformV1AuditLogs(params),
};
